import Swiper from 'swiper/bundle';

export const initTestimonialCarousel = () => {
  new Swiper('.review_carousel__container', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    navigation: {
      nextEl: '.review_carousels__swiperNextBtn',
      prevEl: '.review_carousels__swiperPrevBtn',
    },
    pagination: {
      el: '.review_carousels__pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className} w-2.5 h-2.5 rounded-full bg-gray-200 transition-all duration-300 ease-in-out"></span>`;
      },
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    on: {
      init(swiper) {
        updateNavigationState(swiper);
        updatePaginationStyle();
      },
      slideChange(swiper) {
        updateNavigationState(swiper);
        updatePaginationStyle();
      },
    },
  });

  function updatePaginationStyle() {
    const bullets = document.querySelectorAll(
      '.review_carousels__pagination .swiper-pagination-bullet',
    );
    bullets.forEach((bullet) => {
      if (bullet.classList.contains('swiper-pagination-bullet-active')) {
        bullet.classList.add('w-5', 'h-2.5', 'rounded-md', 'bg-gray-900');
        bullet.classList.remove(
          'w-2.5',
          'h-2.5',
          'rounded-full',
          'bg-gray-200',
        );
      } else {
        bullet.classList.add('w-2.5', 'h-2.5', 'rounded-full', 'bg-gray-200');
        bullet.classList.remove('w-5', 'h-2.5', 'rounded-md', 'bg-gray-900');
      }
    });
  }

  function updateNavigationState(swiper) {
    const prevBtn = document.querySelector('.review_carousels__swiperPrevBtn');
    const nextBtn = document.querySelector('.review_carousels__swiperNextBtn');

    if (!prevBtn || !nextBtn) return;

    prevBtn.style.display = swiper.isBeginning ? 'none' : 'flex';
    nextBtn.style.display = swiper.isEnd ? 'none' : 'flex';
  }
};
